const CommonSidebar = () => import(/* webpackChunkName: "component.header" */ '@/components/Sidebar');
const CommonHeader = () => import(/* webpackChunkName: "component.header" */ '@/components/Header');
const CommonFooter = () => import(/* webpackChunkName: "component.header" */ '@/components/Footer');

export default {
  path: 'administrators',
  components: {
    sidebar: CommonSidebar,
    header: CommonHeader,
    footer: CommonFooter,
    default: () => import(/* webpackChunkName: "module.administrators" */ '@/views/Administrators'),
  },
  meta: {
    breadcrumb: {
      label: 'Administrators',
    },
  },
  children: [
    {
      path: '',
      name: 'administrators-listing',
      component: () => import(/* webpackChunkName: "module.administrators.list" */ '@/modules/Administrators/List'),
      meta: {
        breadcrumb: {
          label: 'Administrators',
        },
      },
    },
    {
      path: ':id/edit',
      name: 'administrators-edit',
      component: () => import(/* webpackChunkName: "module.administrators.edition" */ '@/modules/Administrators/Edition'),
      meta: {
        breadcrumb: {
          parent: 'administrators-listing',
          label: 'Edit Administrator',
        },
      },
    },
    {
      path: 'create',
      name: 'administrators-create',
      component: () => import(/* webpackChunkName: "module.administrators.edition" */ '@/modules/Administrators/Edition'),
      meta: {
        breadcrumb: {
          parent: 'administrators-listing',
          label: 'Create Administrator',
        },
      },
    },
  ],
};
